import {BaseConfig} from "../../infrastructure/config/base-config";
import {NavigationTabsModuleTerms} from "./navigation-tabs-module.terms";

export class NavigationTabsModuleConfig extends BaseConfig {

  static injectables = [NavigationTabsModuleTerms];

  constructor(terms: NavigationTabsModuleTerms) {
    super('navigationTabsModule', null, terms);
  }
}
